import { PLAN } from '@/common/constants/markets';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { IOperationItem } from '@/common/integrations/menhir/employee/operations/operations.types';
import {
  isESChildcareOperationItem,
  isExpenseRejectedOperationItem,
  isRefundOperationItem,
  isReimbursementExpenseOperationItem,
  isVoucherExpenseOperationItem,
} from '@/common/utils/operations';
import { useRouter } from 'expo-router';

export const useOperationAction = () => {
  const { setParams } = useRouter();
  const { company } = useEmployeeDetails();

  const getTransactionAction = (operation: IOperationItem) => {
    if (company.settings.plan === PLAN.ITALY_FRINGE) {
      return undefined;
    }

    if (
      isExpenseRejectedOperationItem(operation) ||
      isVoucherExpenseOperationItem(operation) ||
      isReimbursementExpenseOperationItem(operation) ||
      (isESChildcareOperationItem(operation) &&
        !isRefundOperationItem(operation))
    ) {
      return () => setParams({ operationId: operation.id });
    }
  };

  return { getTransactionAction };
};
